import 'reflect-metadata';
import { Service } from 'typedi';
import { StrategyBuilder } from '../../StrategyBuilder';
import { makeLogger } from '../../../../logger/logger';
import type { IConversationalSearchStrategyData } from '../../types/conversational-search-srategy-data.type';
import { ConversationalSearchStrategyService } from '../../ConversationalSearchStrategyService';

const { info } = makeLogger({
  pathToCurrentFile:
    'components/strategies/services/conversational-search-service/conversational-search-fallback.service.ts',
  loggersList: ['info'],
});

@Service({ id: 'conversationalSearchFallbackStrategyService' })
export class CovnersationalSearchFallbackConfigurationBuilder extends StrategyBuilder<ConversationalSearchStrategyService> {
  build(
    details: IConversationalSearchStrategyData
  ): ConversationalSearchStrategyService {
      return new FallbackConversationalSearchStrategyService(details);
  }
}

export class FallbackConversationalSearchStrategyService extends ConversationalSearchStrategyService {
  details;
  constructor(details: IConversationalSearchStrategyData) {
      super();
      this.details = details;
  }


  getConversationalSearchConfiguration() {
      info('Fallback - Can not load Conversational Search Configuration');

      return this.details;
  }

  getConversationalSearchConfigurationForActiveTab(tabName: string) {
      info(
        `Fallback - Can not load Conversational Search Configuration for ${tabName} tab`
      );

      return this.details;
  }
}
